export default __webpack_public_path__ + "static/media/BG-Green-0004.20b2e561.png";